import { connect } from 'react-redux'

# provide state
mapStateToProps = (state)->
  {session} = state
  {session}

export default connect mapStateToProps
